module.exports = __webpack_public_path__ + "static/beyond_software-b24c6a4c1b9b3731d5235c0be472d5e6.svg";